import React from 'react';
import { useTranslation } from 'react-i18next';
import { FormSelect, FormSwitch } from '../FormInputs';
import type { NarrativeFormData } from '../Forms/types';

interface WidgetsSettingsSubgroupProps {
  form: any;
}

export const WidgetsSettingsSubgroup: React.FC<WidgetsSettingsSubgroupProps> = ({ form }) => {
  const { t } = useTranslation();

  const summaryPanelOptions = [
    { value: 'standard', label: t('Standard') },
    { value: 'custom', label: t('Custom') },
  ];

  const eventCardOptions = [
    { value: 'rating', label: t('Rating') },
    { value: 'messages', label: t('Publications') },
  ];


  const sentimentBarOptions = [
    { value: 'messages', label: t('Publications') },
    { value: 'posts', label: t('Posts') },
  ];

  const topActorsOptions = [
    { value: 'audience', label: t('Sort by audience') },
    { value: 'messages_count', label: t('Sort by number of publications') },
  ];

  const evolutionTabsOptions = [
    { value: 'publications', label: t('Publications') },
    { value: 'impressions', label: t('Views') },
    { value: 'engagement', label: t('Engagement') },
  ];

  const evolutionBreakdownsOptions = [
    { value: 'aggregation', label: t('Stats aggregation') },
    { value: 'breakdown', label: t('Stats breakdown') },
  ];

  return (
    <div className="form-element-group">
      <FormSelect
        form={form}
        name="summaryPanel"
        label={t('Summary panel')}
        placeholder={t('Select option')}
        options={summaryPanelOptions}
      />

      <div className='divider' />

      <FormSelect
        form={form}
        name="eventCard"
        label={t('Event card')}
        placeholder={t('Select option')}
        options={eventCardOptions}
      />

      <div className='divider' />

      <FormSelect
        form={form}
        name="sentimentBar"
        label={t('Sentiment bar')}
        placeholder={t('Select options')}
        options={sentimentBarOptions}
        isMulti
      />

      <div className='divider' />

      <FormSwitch
        form={form}
        name="geoWidget"
        label={t('Geo widget')}
      />

      <div className='divider' />

      <FormSelect
        form={form}
        name="topActors"
        label={t('Top actors')}
        placeholder={t('Select option')}
        options={topActorsOptions}
      />

      <div className='divider' />

      <FormSwitch
        form={form}
        name="actorTypes"
        label={t('Actor types')}
      />

      <div className='divider' />

      <FormSwitch
        form={form}
        name="evolutionChart"
        label={t('Evolution chart')}
      />

      <FormSelect
        form={form}
        name="evolutionTabs"
        label={t('Evolution chart tabs')}
        placeholder={t('Select options')}
        options={evolutionTabsOptions}
        isMulti
      />

      <FormSelect
        form={form}
        name="evolutionBreakdowns"
        label={t('Evolution chart breakdowns')}
        placeholder={t('Select options')}
        options={evolutionBreakdownsOptions}
        isMulti
      />
    </div>
  );
};